// src/components/postAd/AIUploader.js
import React, { useState } from 'react';
import { usePostAd } from '../../contexts/PostAdContext';
import { AIListingService } from '../../services/AiListingService';
import { hydrateAdData } from '../../utils/adHydrator';
import { findSubCategoryId } from '../../utils/categoryMapper';
import { FiCamera, FiX, FiZap, FiArrowLeft } from 'react-icons/fi';

const aiService = new AIListingService();

const AIUploader = () => {
  const { setPhotos, setPreviews, setAdData, setSelectedCategory, setSelectedSubCategory, setStep, photos, previews } = usePostAd();
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const remainingSlots = 10 - photos.length;
    const filesToAdd = files.slice(0, remainingSlots);

    const newPhotos = [...photos, ...filesToAdd];
    const newPreviews = filesToAdd.map(file => URL.createObjectURL(file));
    
    setPhotos(newPhotos);
    setPreviews([...previews, ...newPreviews]);
  };

  const removePhoto = (index) => {
    setPhotos(photos.filter((_, i) => i !== index));
    setPreviews(previews.filter((_, i) => i !== index));
  };

  const triggerMagic = async () => {
    if (photos.length === 0) return;
    setIsAnalyzing(true);

    try {
      // 1. Send all selected photos to Gemini for analysis
      const suggestion = await aiService.analyzeProduct(photos);

      // 2. Map AI strings to our internal IDs
      const mapped = findSubCategoryId(suggestion.category, suggestion.subCategory);
      
      // 3. Hydrate form fields dynamically
      const hydratedFields = hydrateAdData(suggestion, mapped.categoryId);

      setSelectedCategory(mapped.categoryId);
      setSelectedSubCategory(mapped.subCategoryId);
      setAdData(hydratedFields);
      setStep(3); // Move to Dynamic Form
    } catch (err) {
      alert(err.message || "Qobo couldn't analyze these photos. Try again or post manually.");
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <div className="ai-uploader-container">
      <button className="back-nav-btn" onClick={() => setStep(1)}>
                    <FiArrowLeft /> Back
                  </button>
      <h2>Upload photos of your item</h2>
      <p>Upload at least 3 photos for best AI results (Front, Back, Details)</p>

      <div className="photo-grid-large">
        {previews.map((url, index) => (
          <div key={url} className="photo-box">
            <img src={url} alt="preview" />
            <button onClick={() => removePhoto(index)} className="remove-btn"><FiX /></button>
          </div>
        ))}
        
        {photos.length < 10 && (
          <label className="add-box">
            <input type="file" multiple accept="image/*" onChange={handleFileChange} hidden />
            <FiCamera size={30} />
            <span>Add Photo</span>
          </label>
        )}
      </div>

      <button 
        className="magic-action-btn" 
        onClick={triggerMagic} 
        disabled={photos.length === 0 || isAnalyzing}
      >
        {isAnalyzing ? (
          <div className="loader-flex"><div className="spinner-white"></div> Analyzing...</div>
        ) : (
          <><FiZap /> Start Qobo Magic</>
        )}
      </button>
    </div>
  );
};

export default AIUploader;